import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  text?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  className, 
  size = 'lg', 
  text = 'Loading...',
  fullScreen = false
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const containerClasses = fullScreen 
    ? 'fixed inset-0 bg-white/80 z-50' 
    : 'w-full h-full min-h-[200px]';

  return (
    <div className={cn("flex flex-col items-center justify-center", containerClasses, className)}>
      <Loader2 className={cn("animate-spin text-primary-600", sizeClasses[size])} />
      {text && (
        <p className="mt-4 text-sm font-medium text-gray-500 animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
};
